export const logos = [
  {
    src: "/logos/runway.png",
    alt: "Runway"
  },
  {
    src: "/logos/plastic-odyssey.png",
    alt: "Plastic Odyssey"
  },
  {
    src: "/logos/imax.png",
    alt: "IMAX"
  },
  {
    src: "/logos/aftershoot.png",
    alt: "Aftershoot"
  },
  {
    src: "/logos/beyond.png",
    alt: "Beyond Capture Studios"
  },
  {
    src: "/logos/capcut.png",
    alt: "CapCut"
  }
];
